import { EVENT_NAMES, EVENT_CATEGORIES, HIT_TYPE } from 'app-webtech-core/beacon/const';
import { getCmFields } from './helpers/getCmFields';

// eslint-disable-next-line no-unused-vars
export const cmPodCompleteBeacon = (action, prevState, nextState) => {
  const { adBreakDuration } = action.payload;
  const cmFields = getCmFields({ adBreakDuration, resetDurationServed: true });
  return {
    hitType: HIT_TYPE.EVENT,
    eventCategory: EVENT_CATEGORIES.CM,
    eventName: EVENT_NAMES.CM_POD_COMPLETE,
    ...cmFields,
  };
};
